import { render } from "./add-attendance-model.vue?vue&type=template&id=0199f5df&scoped=true"
import script from "./add-attendance-model.vue?vue&type=script&lang=js"
export * from "./add-attendance-model.vue?vue&type=script&lang=js"

import "./add-attendance-model.vue?vue&type=style&index=0&id=0199f5df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0199f5df"]])

export default __exports__